import request from './request.js';
import configHttp from '../../configHttp.js'
import {
	requestbody
} from './request.js'
//权限相关
export async function importExcel(params = {

}) {
	return await request('balance/importExcel', 'post', params)
}
export async function mappingrulepage(params = {

}) {
	return await request('mappingEx/rule/page', 'post', params)
}
export async function companysPage(params = {

}) {
	return await request('mapping-rulefunc/companysPage', 'post', params)
}
export async function saveMappingRule(params = {

}) {
	return await requestbody('mapping-rulefunc/saveMappingRule', 'post', params)
}
export async function delMappingRule(params = {

}) {
	return await requestbody('mapping-rulefunc/delMappingRule', 'post', params)
}
//根据映射规则编码或id分页得到Mapping集合
export async function getMappingPageListByRule(params = {

}) {
	return await request('mapping-rulefunc/getMappingPageListByRule', 'post', params)
}
//根据id获取详情
export async function mappingrulefuncgetById(params = {

}) {
	return await requestbody('mapping-rulefunc/getById', 'post', params)
}
//修改科目映射规则
export async function updateMappingRule(params = {

}) {
	return await requestbody('mapping-rulefunc/updateMappingRule', 'post', params)
}
//获取列表
export async function getTempBlanceDataPage(params = {

}) {
	return await request('mapping/getTempBlanceDataPage', 'post', params)
}
//
export async function queryCompanySz(params = {

}) {
	return await request('sys/queryCompanySz', 'post', params)
}
//获取科目详情
export async function getDetailById(params = {

}) {
	return await requestbody('mapping/getDetailById', 'post', params)
}
//新增科目信息
export async function saveMapping(params = {

}) {
	return await requestbody('mapping/saveMapping', 'post', params)
}
//编辑科目信息
export async function updateMapping(params = {

}) {
	return await requestbody('mapping/updateMapping', 'post', params)
}
//映射关系导入
export async function importMapping(params = {

}) {
	return await request('mapping/importMapping', 'post', params)
}
//清除映射
export async function clearMapping(params = {

}) {
	return await requestbody('mapping/clearMapping', 'post', params)
}
//根据导入批次号得到导入模板中公司集合信息
export async function getSubjectCompanys(params = {

}) {
	return await requestbody('mapping/getSubjectCompanys', 'post', params)
}
//上传科目映射保存提交
export async function checkMapping(params = {

}) {
	return await requestbody('mapping/checkMapping', 'post', params)
}
//科目余额分页查询
export async function balancePage(params = {

}) {
	return await request('balance/page', 'post', params)
}
//上传历史记录分页查询
export async function uploadhistorypage(params = {

}) {
	return await request('input-history/page', 'post', params)
}
//下载原文件
export async function downloadOriginalFile(params = {

}) {
	return await requestbody('upload-history/downloadOriginalFile', 'post', params)
}

//下载原文件
export async function uploadhistorydelete(params = {

}) {
	return await requestbody('upload-history/deleteBatch', 'post', params)
}
//模板信息分页查询
export async function templateInfopage(params = {

}) {
	return await request('template-info/page', 'post', params)
}
//删除模板
export async function deleteTemplate(params = {

}) {
	return await requestbody('template-info/deleteTemplate', 'post', params)
}
//获取模板
export async function getTemplate(params = {

}) {
	return await requestbody('template-info/getTemplate', 'post', params)
}
//获取文件表头
export async function getFileColumn(params = {

}) {
	return await request('template-info/getFileColumn', 'post', params)
}
//添加自定义模板
export async function templateInfoSave(params = {

}) {
	return await requestbody('template-info/save', 'post', params)
}
//根据id获取模板详情
export async function getTemplateById(params = {

}) {
	return await requestbody('template-info/getTemplateById', 'post', params)
}
//根据id获取模板详情
export async function templateinfoupdate(params = {

}) {
	return await requestbody('template-info/update', 'post', params)
}


export async function getUserInfo(params = {

}) {
	return await request('getUserInfo', 'GET', params)
}
export async function checkoutUserPeriod(params = {

}) {
	return await request('sys/checkoutUserPeriod', 'post', params)
}

export async function moduleInfo(params = {

}) {
	return await requestbody('home/moduleInfo', 'post', params)
}
export async function getReportAdditionalInfo(params = {

}) {
	return await request('manuscript/getReportAdditionalInfo', 'post', params)
}
//获取进行增值税的模板
// export async function iinv_templateIinvUpload(params = {

// }) {
// 	return await requestbody('IINV/uploadInvTemplate', 'post', params)
// }

//获取登录验证码
export async function verifyCode(params = {}) {
	return await request('/base/sys/verifyCode', 'get', params)
}
//登录接口
export async function loginv2(params = {}) {
	return await request('/base/sys/user/login/v2', 'post', params)
}
//门户网站单点登录
export async function familyLogin(params = {}) {
	return await request('/base/sys/family/familyLogin', 'post', params)
}
//获取权限菜单接口
export async function getRoleMenuIdListByUser(params = {}) {
	return await request('/base/sys/function/getRoleMenuIdListByUser', 'post', params)
}
//退出登录
export async function ssologoutsaml(params = {}) {
	return await request('/sso/logoutsaml', 'post', params)
}

//获取实体信息
export async function stxxgetv2(params = {}) {
	return await request('/base/sys/stxx/get/v2', 'post', params)
}
//用户管理分页
export async function inquiryUser(params = {}) {
	return await request('/sys/manage/inquiryUser', 'post', params)
}
//新增/编辑用户实体
export async function merge(params = {}) {
	return await request('/base/sys/user/merge', 'post', params)
}
//密码校验条件查询
export async function getPwdVerify(params = {}) {
	return await request('/base/sys/user/getPwdVerify', 'get', params)
}
//删除用户
export async function Yhdelete(params = {}) {
	return await request('/base/sys/user/delete', 'post', params)
}
//获取编辑用户
export async function huquyh(params = {}) {
	return await requestbody('/base/sys/user/get/' + params.id, 'get', params)
}

//获取已关联用户
export async function getAssociatedUserInfo(params = {}) {
	return await request('/base/sys/user/getAssociatedUserInfo', 'post', params)
}
//获取未关联用户
export async function getNotAssociatedUserInfo(params = {}) {
	return await request('/base/sys/user/getNotAssociatedUserInfo', 'post', params)
}
//获取权限菜单接口
export async function getTreeListNew(params = {}) {
	return await request('/base/sys/role/getTreeListNew', 'post', params)
}
//角色分页
export async function getRoleData(params = {}) {
	return await request('/base/sys/role/getRoleData', 'post', params)
}
//更新角色用户
export async function updateUsersToRole(params = {}) {
	return await request('/base/sys/role/updateUsersToRole', 'post', params)
}
//保存/修改角色信息
export async function saveOrUpdateRole(params = {}) {
	return await request('/base/sys/role/saveOrUpdateRole', 'post', params)
}
//删除角色
export async function quanxgldelete(params = {}) {
	return await request('/base/sys/role/delete/' + params.id, 'post', params)
}
//更新角色权限
export async function updatePermissionsToRole(params = {}) {
	return await request('/base/sys/role/updatePermissionsToRole', 'post', params)
}
//实体管理分页
export async function getStxxPage(params = {}) {
	return await request('/base/sys/stxx/getStxxPage', 'post', params)
}
//实体管理更新/保存实体基本信息
export async function saveOrUpdateStxx(params = {}) {
	return await request('/base/sys/stxx/saveOrUpdateStxx', 'post', params)
}
//获取编辑实体
export async function compile(params = {}) {
	return await request('/base/sys/stxx/get/' + params.id, 'get', params)
}
//页面查询
export async function inquiryCurrencyConfig(params = {}) {
	return await request('/fvm/query/datagrid/inquiryCurrencyConfig', 'post', params)
}
//币种新增和编辑
export async function saveOrUpdateCurrencyConfig(params = {}) {
	return await request('/fvm/currencyconfig/saveOrUpdateCurrencyConfig', 'post', params)
}
//币种删除
export async function deleteCurrencyConfig(params = {}) {
	return await request('/fvm/currencyconfig/deleteCurrencyConfig', 'post', params)
}
//设置本位币
export async function setStandardCurrency(params = {}) {
	return await request('/fvm/currencyconfig/setStandardCurrency', 'post', params)
}

//获取实体用户分页
export async function findst(params = {}) {
	return await request('/base/sys/user/findst', 'post', params)
}
//获取所有用户
export async function findAll(params = {}) {
	return await request('/base/sys/user/findAll', 'post', params)
}
//获取实体用户ids
export async function getUserSTXX(params = {}) {
	return await request('/base/sys/stxx/getUserSTXX/' + params.stxxId, 'get', params)
}
//更新实体用户配置
export async function doSetUserSTXX(params = {}) {
	return await request('/base/sys/stxx/doSetUserSTXX', 'post', params)
}
//定时任务实例分页
export async function inquiryScheduleTaskInstance(params = {}) {
	return await request('/base/scheduletask/inquiryScheduleTaskInstance', 'post', params)
}
//获取定时任务类型
export async function getTaskTypeList(params = {}) {
	return await request('/base/scheduletask/getTaskTypeList', 'post', params)
}
//定时任务实例添加/修改
export async function saveOrUpdateInstance(params = {}) {
	return await request('/base/scheduletask/saveOrUpdateInstance', 'post', params)
}
//获取编辑定时任务
export async function scheduletaskget(params = {}) {
	return await request('/base/scheduletask/get/' + params.id, 'get', params)
}
//定时任务启用/停用切换
export async function switchStatus(params = {}) {
	return await request('/base/scheduletask/switchStatus', 'post', params)
}
//企业科目分页
export async function inquiryCompanyAccount(params = {}) {
	return await request(configHttp.projectType == 'Amat' ? '/amat/query/datagrid/inquiryCompanyAccount' : '/fvm/query/datagrid/inquiryCompanyAccount', 'post', params)
}

//获取中方科目代码
export async function getCACodeDesc(params = {}) {
	return await request('/fvm/companyaccount/getCACodeDesc', 'post', params)
}
//获取当前引用账套是否已设置了年结科目
export async function getAccountingDate(params = {}) {
	return await request('/fvm/companyaccount/getAccountingDate', 'post', params)
}
//总账查看
export async function inquiryKmzz(params = {}) {
	return await request('/fvmQuery/inquiryKmzz', 'post', params)
}
//查看明细账表
export async function inQueryDetail(params = {}) {
	return await request('/fvmQuery/queryDetail', 'post', params)
}
//查看明细账表外部数据
export async function inQueryDetailInfo(params = {}) {
	return await request('/fvmQuery/queryDetail/info', 'post', params)
}

//获取科目等级
export async function getaccountLevel(params = {}) {
	return await request('/fvm/companyaccount/getaccountLevel', 'post', params)
}

//获取中方科目类型
export async function getCombo(params = {}) {
	return await request('/base/sys/config/getCombo', 'post', params)
}
//新增与编辑
export async function saveOrUpdateCA(params = {}) {
	return await request('/fvm/companyaccount/saveOrUpdateCA', 'post', params)
}
//获取企业科目编辑数据
export async function loadCA(params = {}) {
	return await request('/fvm/companyaccount/loadCA', 'post', params)
}
//删除企业科目
export async function deleteCompanyAccount(params = {}) {
	return await request('/fvm/companyaccount/deleteCompanyAccount', 'post', params)
}
//导出企业科目
export async function exportca(params = {}) {
	return await request('/fvm/excel/export/ca', 'get', params)
}
//导入企业科目
export async function importcompanyaccount(params = {}) {
	return await request(configHttp.projectType == 'Amat' ? '/amat/companyaccount/import' : '/fvm/companyaccount/import', 'post', params)
}
//科目映射分页
export async function inquiryCompanyAccountMapping(params = {}) {
	return await request('/fvm/query/datagrid/inquiryCompanyAccountMapping', 'get', params)
}

//获取科目代码
export async function getLastCACodeDesc(params = {}) {
	return await request('/fvm/companyaccount/getLastCACodeDesc', 'post', params)
}

//获取当前企业下分析代码别名
export async function inquiryTCodeAliasConfig(params = {}) {
	return await request('/fvm/aliasconfig/inquiryTCodeAliasConfig', 'post', params)
}
//新增与编辑科目映射
export async function saveOrUpdateCAM(params = {}) {
	return await request('/fvm/companyaccount/saveOrUpdateCAM', 'post', params)
}
//获取科目映射编辑数据
export async function loadCAM(params = {}) {
	return await request('/fvm/companyaccount/loadCAM', 'post', params)
}
//删除科目映射
export async function deleteCAM(params = {}) {
	return await request('/fvm/companyaccount/deleteCAM', 'post', params)
}

//导入科目映射
export async function companyaccountimportMapping(params = {}) {
	return await request('/fvm/companyaccount/importMapping', 'post', params)
}

//获取所有一级科目
export async function getFirstLevelAccounts() {
	return await request('/fvm/companyaccount/getFirstLevelAccounts', 'post')
}





//财年页面查询
export async function inquiryFiscalYearConfigv2(params = {}) {
	return await request('/fvm/query/datagrid/inquiryFiscalYearConfig/v2', 'post', params)
}
//新增或编辑财年
export async function saveOrUpdateFiscalYearConfig(params = {}) {
	return await request('/fvm/fiscalyearconfig/saveOrUpdateFiscalYearConfig', 'post', params)
}
//删除财年
export async function deleteFiscalYearConfig(params = {}) {
	return await request('/fvm/fiscalyearconfig/deleteFiscalYearConfig', 'get', params)
}

//分析代码页面查询
export async function inquiryAnalisiscode(params = {}) {
	return await request('/fvm/query/datagrid/inquiryAnalisiscode', 'post', params)
}
//分析代新增与编辑
export async function saveOrUpdateTcode(params = {}) {
	return await request('/fvm/analysiscode/saveOrUpdateTcode', 'post', params)
}

//用于combobox时的模糊查询，获取不是末级科目代码及科目描述
export async function getindexofCACodeDesc(params = {}) {
	return await request('/fvm/companyaccount/getindexofCACodeDesc', 'post', params)
}
//获取分析代码
export async function inquiryAliasConfig(params = {}) {
	return await request('/fvm/aliasconfig/inquiryAliasConfig', 'get', params)
}
//导入接口分析代码
export async function importanalysiscode(params = {}) {
	return await request('/fvm/analysiscode/import', 'post', params)
}
//分析代码页面删除
export async function deleteTCode(params = {}) {
	return await request('/fvm/analysiscode/deleteTCode', 'get', params)
}
//加载单条数据
export async function loadTcode(params = {}) {
	return await request('/fvm/analysiscode/loadTcode', 'get', params)
}
//账套页面查询
export async function inquiryDataGroup(params = {}) {
	return await request('/fvm/datagroup/inquiryDataGroup', 'post', params)
}
//新增或者修改
export async function append(params = {}) {
	return await request('/fvm/datagroup/append', 'post', params)
}
//根据id查询
export async function queryDataGroupById(params = {}) {
	return await request('/fvm/datagroup/queryDataGroupById', 'get', params)
}
//删除
export async function delteDatagroup(params = {}) {
	return await request('/fvm/datagroup/delteDatagroup', 'get', params)
}
//设置引用
export async function setReference(params = {}) {
	return await request('/fvm/datagroup/setReference', 'get', params)
}
//新增或修改当前企业别名配置
export async function insertOrUpdateAliasConfig(params = {}) {
	return await requestbody('/fvm/aliasconfig/insertOrUpdateAliasConfig', 'post', params)
}


//任务分页
export async function inquiryFileImport(params = {}) {
	return await request('/fvm/query/datagrid/inquiryFileImport', 'post', params)
}

//删除导入任务
export async function deletebackGroundTaskData(params = {}) {
	return await request('/backGroundTask/deletebackGroundTaskData', 'post', params)
}
//过账/反过账
export async function posting(params = {}) {
	return await request('/backGroundTask/posting', 'get', params)
}
//文件导入
export async function fileImportUpload(params = {}) {
	return await request('/backGroundTask/fileImportUpload', 'post', params)
}
//获取导入凭证模板类型
export async function getTemplateName(params = {}) {
	return await request('/voucher/template/getTemplateName', 'post', params)
}
//下载日志文件
export async function downloadOriginalDdocument(params = {}) {
	return await request('/backGroundTask/downloadOriginalDdocument', 'get', params)
}
//下载原文件
export async function downloadLog(params = {}) {
	return await request('/backGroundTask/downloadLog', 'get', params)
}
//凭证查询页面查询
export async function queryVoucherHeaderData(params = {}) {
	return await request('/fvm/voucher/queryVoucherHeaderData', 'post', params)
}

//页面查询
export async function templategetTemplate(params = {}) {
	return await request('/sys/template/getTemplate', 'post', params)
}
//删除凭证映射模板配置
export async function deleteMappingTemplateConfig(params = {}) {
	return await request('/voucher/template/deleteMappingTemplateConfig', 'get', params)
}
//导入按钮，字段名和对应位置
export async function uploadTemplateText(params = {}) {
	return await request('/sys/template/uploadTemplateText', 'post', params)
}
//获取实体配置表中的所有字段名
export async function getColumnNames(params = {}) {
	return await request('/sys/template/getColumnNames', 'get', params)
}

//凭证模板新增与编辑
export async function saveOrUpdateMappingTemplateConfig(params = {}) {
	return await request('/voucher/template/saveOrUpdateMappingTemplateConfig', 'post', params)
}
//根据id获取数据
export async function getTemplateConfig(params = {}) {
	return await request('/voucher/template/getTemplateConfig', 'get', params)
}



//报表通用查询
export async function inquiryReport(params = {}) {
	return await request('/fvm/query/datagrid/inquiryReport', 'post', params)
}
//报表通用删除
export async function deleteBackgroundTask(params = {}) {
	return await request('/backGroundTask/deleteBackgroundTask ', 'post', params)
}
//报表下载
export async function downloadNormReportFile(params = {}) {
	return await request('/backGroundTask/downloadNormReportFile', 'get', params)
}


//获取财务年度
export async function getYear(params = {}) {
	return await request('/fvm/query/datagrid/getYear', 'get', params)
}
//根据财务年度获取财务期间
export async function getFinancialPeriod(params = {}) {
	return await request(configHttp.projectType == 'Amat' ? '/amat/base/sys/config/getFinancialPeriod' : '/base/sys/config/getFinancialPeriod', 'get', params)
}
//获取所有明细类型
export async function getDetailType(params = {}) {
	return await request('/base/sys/config/getDetailType', 'get', params)
}
//查询指定分析代码
export async function getTCodeByNumber(params = {}) {
	return await request('/fvm/analysiscode/getTCodeByNumber', 'get', params)
}
//报表生成
export async function reportSubmit(params = {}) {
	return await request('/backGroundTask/reportSubmit', 'post', params)
}

//Amat定制报表生成
export async function amatReportSubmit(params = {}) {
	return await request('/amat/backGroundTask/reportSubmit', 'post', params)
}

//将报表模板文件上传
export async function templateFileUpload(params = {}) {
	return await request('/fvm/report/templateFileUpload', 'post', params)
}

//保存报表模板文件
export async function saveReportTemplateFile(params = {}) {
	return await request('/fvm/report/saveReportTemplateFile', 'post', params)
}

//获取当前生成的ERP凭证号
export async function getNewErpNo(params = {}) {
	return await request('/fvm/sequenceno/getNewErpNo', 'post', params)
}
//币种下拉
export async function getCurrencyConfigData(params = {}) {
	return await request('/fvm/currencyconfig/getCurrencyConfigData', 'post', params)
}

//模糊查询外方科目
export async function getErp(params = {}) {
	return await request('/fvm/query/datagrid/getErp', 'get', params)
}
//凭证新增或编辑
export async function saveOrUpdateVoucher(params = {}) {
	return await request('/fvm/voucher/saveOrUpdateVoucher', 'post', params)
}


//校验创建凭证
export async function validateCreateCondition(params = {}) {
	return await request('/fvm/voucher/validateCreateCondition', 'get', params)
}




//查询单个凭证
export async function queryVoucherInfo(params = {}) {
	return await request('/fvm/voucher/queryVoucherInfo', 'post', params)
}
//获取当前凭证的下一张的ID
export async function getNextVoucherId(params = {}) {
	return await request('/fvm/voucher/getNextVoucherId', 'get', params)
}
//获取当前凭证的上一张的IDID
export async function getBeforeVoucherId(params = {}) {
	return await request('/fvm/voucher/getBeforeVoucherId', 'get', params)
}
//单张凭证过账
export async function postVoucher(params = {}) {
	return await request('/fvm/voucher/postVoucher', 'get', params)
}

//单张凭证反过账
export async function unPostVoucher(params = {}) {
	return await request('/fvm/voucher/unPostVoucher', 'get', params)
}
//删除凭证
export async function deleteVoucher(params = {}) {
	return await request('/fvm/voucher/deleteVoucher', 'get', params)
}
//查询当前用户的实体
export async function dggqueryv2(params = {}) {
	return await request('/base/genericdata/query/dggquery/v2', 'post', params)
}

//切换实体
export async function optionv2(params = {}) {
	return await request('/base/sys/stxx/option/v2/'+params.id, 'get', params)
}
//查询通用配置
export async function inquiryCommon(params = {}) {
	return await request('/amatCommon/inquiryCommon', 'post', params)
}
//新增通用配置
export async function addCommon(params = {}) {
	return await request('/amatCommon/addCommon', 'post', params)
}
//修改通用配置
export async function updCommon(params = {}) {
	return await request('/amatCommon/updCommon', 'post', params)
}
//删除通用配置
export async function delCommon(params = {}) {
	return await request('/amatCommon/delCommon', 'post', params)
}
//导入通用配置
export async function importCommon(params = {}) {
	return await request('/amatCommon/importCommon', 'post', params)
}


//查询直接法配置
export async function cashFlowConfiginquiryCommon(params = {}) {
	return await request('/cashFlowConfig/inquiryCommon', 'post', params)
}
//删除直接法配置
export async function delConfig(params = {}) {
	return await request('/cashFlowConfig/delConfig', 'post', params)
}


//新增通用配置
export async function cashFlowConfigaddCommon(params = {}) {
	return await request('cashFlowConfig/addConfig', 'post', params)
}
//修改通用配置
export async function cashFlowConfigupdCommon(params = {}) {
	return await request('cashFlowConfig/updConfig', 'post', params)
}
//查询导入任务
export async function amatTaskinquiryFileImport(params = {}) {
	return await request('amatTask/inquiryFileImport', 'post', params)
}


//GL导入
export async function ImportGLFile(params = {}) {
	return await request('/gl/importGLFile', 'post', params)
}

//CF导入
export async function cfimportCFFile(params = {}) {
	return await request('/cf/importCFFile', 'post', params)
}

//VP导入
export async function vpimportVPFile(params = {}) {
	return await request('/vp/importVPFile', 'post', params)
}

//CostCenter导入
export async function costCenterimportCostCenterFile(params = {}) {
	return await request('/costCenter/importCostCenterFile', 'post', params)
}
//删除导入任务
export async function delAmatTask(params = {}) {
	return await request('/amatTask/delAmatTask', 'post', params)
}
//下载错误日志
export async function amatTaskdownloadLog(params = {}) {
	return await request('/amatTask/downloadLog', 'post', params)
}
//下载原文件
export async function amatTaskdownloadOriginalDdocument(params = {}) {
	return await request('/amatTask/downloadOriginalDdocument', 'post', params)
}

//手工调整导入
export async function amatManualAdjustmentImportfileImport(params = {}) {
	return await request('amatManualAdjustmentImport/fileImport', 'post', params)
}
//GL手工调整导入
export async function adjustManuallyImportGLFile(params = {}) {
	return await request('gl/adjustManuallyImportGLFile', 'post', params)
}


//CF直接法数据查询
export async function cfqueryCf(params = {}) {
	return await request('cf/queryCf', 'post', params)
}
//手工调整项目代码
export async function cfadjustManually(params = {}) {
	return await request('cf/adjustManually', 'post', params)
}
//VP供应商数据查询
export async function vpqueryVp(params = {}) {
	return await request('/vp/queryVp', 'post', params)
}

//单点登录接口
export async function ssoLogin(params = {}) {
	return await request('/sso/ssoLogin', 'post', params)
}

//获取产品版本信息
export async function getProductVersionInfo(params = {}) {
	return await request('/fvm/version/getProductVersionInfo', 'post', params)
}

//凭证数据统计
export async function voucherDataStatistics(params = {}) {
	return await request('/fvm/index/voucherDataStatistics', 'post', params)
}
//凭证数据量对比
export async function voucherDataContrast(params = {}) {
	return await request('/fvm/index/voucherDataContrast', 'post', params)
}
//待处理凭证数据
export async function pendingData(params = {}) {
	return await request('/fvm/index/pendingData', 'post', params)
}

//获取产品授权码日期
export async function getRegisterDeadline(params = {}) {
	return await request('/fvm/index/getRegisterDeadline', 'post', params)
}

//GL文件重新导入
export async function reimportGL(params = {}) {
	return await request('/gl/reimportGL', 'post', params)
}

//CF、VP、CostCenter文件重新导入
export async function reimport(params = {}) {
	return await request('/amatTask/reimport', 'post', params)
}

//CF直接法配置导入
export async function importCfConfig(params = {}) {
	return await request('/cashFlowConfig/importCfConfig', 'post', params)
}

//密码修改
export async function updateUserPwd(params = {}) {
	return await request('/base/sys/user/updateUserPwd', 'post', params)
}